import React from 'react'

import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { Box, Fade, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

import { colors } from 'common/colors'
import AvatarIcon from 'components/AvatarIcon'

const useStyles = makeStyles((theme) => ({
  message: {
    marginTop: theme.spacing(3),
  },
}))

const Success = ({ message, secondaryMessage, style }) => {
  const styles = useStyles()

  return (
    <div style={style}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        p={8}
      >
        <AvatarIcon
          icon={faCheck}
          color={colors.success.main}
          size="lg"
        />
        <Typography
          className={styles.message}
          variant="h6"
          component="h3"
        >
          {message}
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
        >
          {secondaryMessage || "This step is now complete and you're ready to move on to the next."}
        </Typography>
      </Box>
    </div>
  )
}

Success.propTypes = {
  message: PropTypes.string.isRequired,
  secondaryMessage: PropTypes.string,
  style: PropTypes.any,
}

const FadeInSuccess = ({ message, secondaryMessage, success }) => (
  <Fade
    in={success}
    timeout={1000}
  >
    <Success
      message={message}
      secondaryMessage={secondaryMessage}
    />
  </Fade>
)

FadeInSuccess.propTypes = {
  message: PropTypes.string.isRequired,
  secondaryMessage: PropTypes.string,
  success: PropTypes.bool.isRequired,
}

export default FadeInSuccess
